import { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import {
    DndContext,
    DragEndEvent,
    DragOverEvent,
    DragOverlay,
    DragStartEvent,
    PointerSensor,
    useSensor,
    useSensors,
    MouseSensor,
} from "@dnd-kit/core";
import { useParams } from "react-router-dom";
//Components
import useAppState from "../../context/useAppState";
import Block from "./Block";
import { SortableContext, arrayMove } from "@dnd-kit/sortable";
import Card from "./Card";
// Icon
import PlusIcon from "../../assets/images/plus-icon-3.svg";
import timelineIcon from "../../assets/images/timeline-icon.svg";
import boardIcon from "../../assets/images/board-icon.svg";
import historyIcon from "../../assets/images/history-icon.svg";
import addNewBlockImg from "../../assets/images/add-new-block.svg";
import dummyImg1 from "../../assets/images/dummy-img-1.png";
import allImgPaths from "assets/images";
import { DEFAULT_BLOCK_IMAGES_BASE_URL } from "utils/constant";
import { CardWrapperLoader } from "components/loaders";
import { updatePositions } from "services/event";
import Insights from "./Insights";
import CustomizeInsight from "components/CustomizeInsight";
import ReviewSpace from "components/reviewspace/ReviewSpace";
import React from "react";
import CustomCheckBox from "components/CustomCheckBox";
import { Filter_Member_data, Filter_data } from "components/history/historyData";
import HistoryTimesLab from "components/history/HistoryTimesLab";
import HistoryContainer from "./HistoryContainer";


function CardWrapper(props: any) {
    const [isSeletcted, setIsSeletcted] = useState(-1);
    const [toggle, setToggle] = useState(0);
    const [togglePlanning, setTogglePlanning] = useState(0);
    const [togglePlanningRightMenu, setTogglePlanningRightMenu] = useState(0);
    const scrollableDivRef = useRef<HTMLDivElement>(null);
    const [isShow, setIsShow] = useState(false);
    const [isActiveColumn, setIsActiveColumn] = useState(0);

    const { id } = useParams();


    const {
        getBoardData,
        cards,
        columns,
        activeColumn,
        deleteColumn,
        updateColumn,
        createCard,
        deleteCard,
        activeCard,
        createNewColumn,
        updateCard,
        isBlockCallApi,
        setState: setCardWrapperState,
        cardWrapperLoading
    } = useAppState('cardWrapper');

    const columnsId: any = useMemo(() => columns?.map((col: any) => col.id), [columns]);

    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 10,
            },
        }),
        useSensor(MouseSensor)
    );

    const handleCustomizeInsights = () => {
        setIsShow(!isShow);
    };

    const [showGraph, setShowGraph] = useState({
        feteCountDown: true,
        budgetSplit: true,
        contract: true,
        budgetRollOver: true,
        budgetUtilize: true,
        attendee_responses: true,
    });

    function onDragStart(event: DragStartEvent) {

        if (event.active.data.current?.type === "Column") {
            setCardWrapperState({ activeColumn: event.active.data.current.column })
            return;
        }

        if (event.active.data.current?.type === "Card") {

            setCardWrapperState({ activeCard: event.active.data.current.card })
            return;
        }
    }

    function onDragEnd(event: DragEndEvent) {
        setCardWrapperState({ activeColumn: null, activeCard: null })

        const { active, over } = event;
        if (!over) return;

        const activeId = active.id;
        const overId = over.id;

        if (activeId === overId) {

            return;
        }

        const isActiveAColumn = active.data.current?.type === "Column";

        if (!isActiveAColumn) return;

        const activeColumnIndex = columns.findIndex((col: any) => col.id === activeId);
        const overColumnIndex = columns.findIndex((col: any) => col.id === overId);
        const newColumns = arrayMove(columns, activeColumnIndex, overColumnIndex);


        setCardWrapperState({ columns: newColumns })

        finalDrag(newColumns, cards, false, 'block')
    }

    function onDragOver(event: DragOverEvent) {

        const { active, over } = event;
        if (!over) return;

        const activeId = active.id;
        const overId = over.id;

        if (activeId === overId) return;

        const isActiveACard = active.data.current?.type === "Card";
        const isOverACard = over.data.current?.type === "Card";

        if (!isActiveACard) return;

        // When dropping a Card over another Card
        if (isActiveACard && isOverACard) {
            const activeIndex = cards.findIndex((t: any) => t.id === activeId);
            const overIndex = cards.findIndex((t: any) => t.id === overId);
            if (cards[activeIndex].columnId != cards[overIndex].columnId) {
                // Fix introduced after video recording
                cards[activeIndex].columnId = cards[overIndex].columnId;
                const newCards = arrayMove(cards, activeIndex, overIndex - 1)
                setCardWrapperState({ cards: newCards })
                // setCardWrapperState({ cards: arrayMove(cards, activeIndex, overIndex - 1) })
            }
            const newCards = arrayMove(cards, activeIndex, overIndex)
            setCardWrapperState({ cards: newCards })
            // setCardWrapperState({ cards: arrayMove(cards, activeIndex, overIndex) })
            finalDrag(columns, newCards, true, 'card')
        }

        const isOverAColumn = over.data.current?.type === "Column";

        // When dropping a Card over a column
        if (isActiveACard && isOverAColumn) {
            const activeIndex = cards.findIndex((t: any) => t.id === activeId);
            cards[activeIndex].columnId = overId;
            const newCards = arrayMove(cards, activeIndex, activeIndex)
            setCardWrapperState({ cards: newCards })
            // setCardWrapperState({ cards: arrayMove(cards, activeIndex, activeIndex) })
            finalDrag(columns, newCards, true, 'column')
        }
    }

    const finalDrag = async (newColumns: any, newCards: any, cardsArray?: boolean, positionType?: any) => {
        let positions: any[] = [];

        newColumns.map((nc: any, index: number) => {
            positions.push({
                block_id: nc.id,
                position: index + 1,
                cards: []
            })
        })

        if (cardsArray) {
            positions.map((uc: any) => {
                const cards = newCards.filter((card: any) => card.columnId === uc.block_id);
                if (cards?.length) {
                    cards.map((c: any, index: number) => {
                        uc.cards.push({
                            card_id: c._id,
                            position: index + 1
                        })
                    })
                }
            })

        }

        const currentTeam = JSON.parse(localStorage.getItem("selectedTeam") as string);

        await updatePositions(id, { team_id: currentTeam?.currentTeamId, positions, positionType })
    }

    const {
        showInsight,
        setState,
        eventFetchedData,
        fetchEventData,
        updateEventCallApiFlag,
        isEventCallApi,
        openPlanningAnimation,
        showChatbox,
        feteDescriptionLoader
    } = useAppState("eventData");

    const [selectedCardId, setSelectedCardId] = useState("");
    // fetch board data
    useEffect(() => {
        if (isBlockCallApi) {
            getBoardData(id)
        }
    }, [isBlockCallApi])

    const closeBoard = ({ blockIndex, selectedCardId }: any) => {
        setTogglePlanning(0);
        setIsSeletcted(blockIndex)
        setSelectedCardId(selectedCardId)
    }

    const [selectedBoardBlockName, setSelectedBoardBlockName] = useState(null)
    const [selectedBoardBlockId, setSelectedBoardBlockId] = useState(null)
    useEffect(() => {
        setSelectedBoardBlockId(columns?.length && columns[0].id)
        setSelectedBoardBlockName(columns?.length && columns[0].title)
        setIsActiveColumn(0)
    }, [togglePlanning === 1])

    const scrollContainerRef = useRef<HTMLDivElement>(null);

    const handleScroll = (direction: 'left' | 'right') => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                top: 0,
                left: direction === 'left' ? -200 : 200,
                behavior: 'smooth'
            });
        }
    };

    return (
        <>
            <div className="planning-card-wrapper smoothness">
                {/* Cards Upper Bar */}
                <div className="flex items-start justify-between card-anim-wrapper">
                    <div>
                        <ul className="flex items-center rounded-corner border-b border-transparent -mb-0.5">
                            <li onClick={(e) => { setToggle(0); setTogglePlanning(0); setState({ showInsight: false, showReviewSpace: false }); }} className={`font-interSemiBold text-base cursor-pointer hover:text-[#F154FF] ${toggle === 0 && togglePlanning === 0 ? "text-[#F154FF] remove-border-bottom " : "text-[#667085]"}`}>Planning</li>

                            {/* <li onClick={(e) => setToggle(1)} className={`font-interSemiBold text-base cursor-pointer ${toggle === 1 ? "text-[#786CF9] remove-border-bottom !z-10 " : "text-[#667085]"}`}>Sponsorship</li> */}

                            <li onClick={(e) => setToggle(2)} className={`font-interSemiBold text-base cursor-pointer hover:text-[#1E0AF5] ${toggle === 2 ? "text-[#1E0AF5] remove-border-bottom !z-10 " : "text-[#667085]"}`}>Insights</li>
                        </ul>
                    </div>

                    {toggle === 0 &&
                        <div className="-mt-0.5">
                            <ul className="flex items-center shadow-customShadow4">
                                <li onClick={(e) => { setTogglePlanning(1); setState({ isInsightCallApi: true }) }} className={`${togglePlanning === 1 ? "bg-[#FBCCFF] border-[#FBCCFF] pointer-none text-[#F154FF]" : "bg-[#fff] text-[#667085]"} font-interSemiBold text-base py-2.5 px-3.5 border hover:border-[#FBCCFF] border-[#D0D5DD] rounded-tl-lg rounded-bl-lg flex items-center gap-x-2 cursor-pointer`}>
                                    <img className={`${togglePlanning === 1 ? "filter-pink" : ""}`} src={boardIcon} alt="board" />
                                    <span className="text-sm font-interSemiBold">Board</span>
                                </li>

                                {/* <li onClick={(e) => setTogglePlanning(2)} className={`${togglePlanning === 2 ? "bg-[#FBCCFF] pointer-none text-[#F154FF]" : "bg-[#fff] text-[#667085]"} font-interSemiBold text-base py-2.5 px-3.5 border border-[#FBCCFF] flex items-center gap-x-2 cursor-pointer`}>
                                    <img className={`${togglePlanning === 2 ? "filter-pink" : ""}`} src={timelineIcon} alt="timeline" />
                                    <span className="text-sm font-interSemiBold">Timeline</span>
                                </li> */}

                                <li onClick={(e) => setTogglePlanning(3)} className={`${togglePlanning === 3 ? "bg-[#FBCCFF] pointer-none border-[#FBCCFF] text-[#F154FF]" : "bg-[#fff] text-[#667085]"} font-interSemiBold text-base py-2.5 px-3.5 border hover:border-[#FBCCFF] border-[#D0D5DD] flex items-center gap-x-2 cursor-pointer rounded-tr-lg rounded-br-lg`}>
                                    <img className={`${togglePlanning === 3 ? "filter-pink" : ""}`} src={allImgPaths.historyIcon} alt="timeline" />
                                    <span className="text-sm font-interSemiBold">History</span>
                                </li>
                            </ul>
                        </div>
                    }

                    {
                        toggle === 2 &&
                        <div className="-mt-0.5">

                            <ul className="flex items-center gap-x-4">
                                <div className="relative">
                                    <li onClick={handleCustomizeInsights} className={`font-interSemiBold text-base text-[#667085] py-2 px-3.5 border-2 border-[#1E0AF5] rounded-lg flex items-center gap-x-2 cursor-pointer shadow-customShadow3 hover:bg-[#E8E6FE] ${isShow === true ? 'bg-[#E8E6FE]' : ''}`}>
                                        <img src={allImgPaths.customiseIcon} alt="customise icon" />
                                        <span className="text-[15px] text-[#1E0AF5] font-interSemiBold">Customize</span>
                                    </li>
                                    <CustomizeInsight
                                        isShow={isShow} setIsShow={setIsShow} showGraph={showGraph} setShowGraph={setShowGraph}
                                    />
                                </div>

                                <button className="submit-btn-blue flex justify-center items-center gap-x-2 !px-4 cursor-pointer hover:bg-[#120693]"
                                    onClick={() => {
                                        setState({ openPlanningAnimation: true, showChatbox: true, showInsight: true, showReviewSpace: false, isInsightCallApi: false });
                                        setCardWrapperState({ cardAnimation: false });
                                    }
                                    }>
                                    <img src={allImgPaths.plusCircleIcon} alt="customise icon" />
                                    <span className="text-[15px] font-interSemiBold ">Add New</span>
                                </button>
                            </ul>
                        </div>
                    }
                </div>

                {toggle === 2 && <Insights showGraph={showGraph} />}

                {/* Cards Wrapper */}
                {toggle == 0 && <CardWrapperLoader count={cardWrapperLoading ? 2 : 0} />}
                {!cardWrapperLoading && toggle == 0 && <DndContext
                    sensors={sensors}
                    onDragStart={onDragStart}
                    onDragEnd={onDragEnd}
                    onDragOver={onDragOver}
                >
                    <div ref={scrollableDivRef} className="m-auto flex gap-4 card-anim-primary hide-scrollbar overflow-x-auto !bg-[#F9FAFB] border border-[#EAECF0] rounded-bl-2xl rounded-br-2xl">
                        {/* Planning Card */}
                        {
                            togglePlanning === 0 &&
                            <div className="flex gap-4 card-anim-secondary overflow-x-auto hide-scrollbar">
                                <div className="px-6 py-6 flex gap-x-6 card-anim-tertiary">
                                    <SortableContext items={columnsId}>
                                        {columns.map((col: any, index: number) => (
                                            <Block
                                                key={col.id}
                                                column={col}
                                                deleteColumn={deleteColumn}
                                                updateColumn={updateColumn}
                                                createCard={createCard}
                                                deleteCard={deleteCard}
                                                updateCard={updateCard}
                                                isSeletcted={isSeletcted === index}
                                                onSelect={() => setIsSeletcted(index)}
                                                boardBlock={col}
                                                cards={cards.filter((card: any) => card.columnId === col.id)}
                                                selectedCardId={selectedCardId}
                                                setSelectedCardId={setSelectedCardId}
                                            />
                                        ))}
                                    </SortableContext>
                                    {/* {columns && columns.length > 0 && (
                                        <div className="px-4 pt-4 pb-3 bg-white border-2 border-[#F154FF] rounded-2xl self-start add-card-box">
                                            <img className="rounded-2xl h-[268px] w-[388px] object-cover" src={`${DEFAULT_BLOCK_IMAGES_BASE_URL}/New+Block.svg`} alt="" />
                                            <h5 className="font-interSemiBold text-lg text-[#101828] pl-0.5 py-2.5">New Block</h5>
                                            <button
                                                onClick={() => {
                                                    createNewColumn();
                                                }}
                                                className="border border-[#D0D5DD] rounded-lg px-4 py-3 flex items-center gap-x-2 w-[386px] shadow-customShadow3 justify-center flex-shrink-0 self-start card-anim-add-btn"
                                            >
                                                <img src={PlusIcon} alt="" />
                                                <span className="font-interMedium text-base text-[#1A1F27] ">Add New Block</span>
                                            </button>
                                        </div>
                                    )} */}
                                </div>
                            </div>
                        }

                        {
                            togglePlanning === 1 &&
                            <>
                                <div className="relative">
                                    <div className="bg-[#FFF] border-b border-[#EAECF0]">
                                        <div className="flex items-center justify-center w-full px-6">
                                            <img className="cursor-pointer on-hover-bg-grey rounded" src={allImgPaths.leftArrow} alt="" onClick={() => handleScroll('left')} />
                                            <div id="scrollBoardContainer" ref={scrollContainerRef} className="flex items-center justify-around no-scrollbar overflow-x-auto h-[48px] w-[calc(100vw_-_225px)]">
                                                {columns?.length > 0 && columns.map((column: any, cIndex: any) => (
                                                    <span key={cIndex}
                                                        onClick={() => {
                                                            setIsActiveColumn(cIndex);
                                                            setSelectedBoardBlockId(column.id)
                                                            setSelectedBoardBlockName(column?.title)
                                                        }}
                                                        className={`${isActiveColumn === cIndex ? "text-[#F154FF] planning-board-border-bottom" : "text-[#667085]"} font-interMedium text-base pointer-cursor relative mx-10 flex-shrink-0 hover:text-[#F154FF]`}>
                                                        {column.title}
                                                    </span>
                                                ))}
                                            </div>
                                            <img className="cursor-pointer on-hover-bg-grey rounded" src={allImgPaths.rightArrow} onClick={() => handleScroll('right')} alt="" />
                                        </div>
                                    </div>

                                    <div className="h-2.5 bg-white w-full"></div>

                                    <ReviewSpace
                                        // blockId={columns.find((x: any) => x.title == "Theme & Design").id}
                                        blockId={selectedBoardBlockId}
                                        callFromBoard={true}
                                        closeBoard={closeBoard}
                                        blockName={selectedBoardBlockName}
                                    />
                                </div>
                            </>
                        }

                        {
                            togglePlanning === 2 &&
                            <div className="">
                                <p>timeline</p>
                            </div>
                        }

                        {
                            togglePlanning === 3 &&
                            <>
                                <HistoryContainer />
                            </>

                        }

                    </div>
                    {createPortal(
                        <DragOverlay>
                            {activeColumn && (
                                <div
                                    className="rotate-right"
                                >
                                    <Block
                                        column={activeColumn}
                                        deleteColumn={deleteColumn}
                                        updateColumn={updateColumn}
                                        createCard={createCard}
                                        deleteCard={deleteCard}
                                        updateCard={updateCard}
                                        cards={cards.filter(
                                            (card: any) => card.columnId === activeColumn.id
                                        )}
                                    />
                                </div>
                            )}
                            {activeCard && (
                                <div
                                    className="rotate-right"
                                >
                                    <Card
                                        card={activeCard}
                                        deleteCard={deleteCard}
                                        updateCard={updateCard}
                                    />
                                </div>
                            )}
                        </DragOverlay>,
                        document.body
                    )}
                </DndContext>}
            </div >
        </>
    );
}
export default CardWrapper;